module.exports = __webpack_public_path__ + "static/media/abstract2.8d3853ec.jpg";